import * as THREE from 'three';
import { Box } from "@react-three/flex";
import { useLoader } from '@react-three/fiber';
import Text from '../Models/Text'
import TxtFlex from './TxtFlex';

function ImgFlex({ 
  scale, 
  image,
  align, 
  justify,
  handleThreshold,
  txtOne,
  txtColorOne,
  txtTwo,
  txtColorTwo,
  headshot
}) {

  const texture = useLoader(THREE.TextureLoader, image)

  return(
    <>
      <Box 
        flexDirection='column' 
        justify={justify}
        align={align}
        margin={scale}
        receiveShadow
      >
        <mesh
          position-z={0.5}
        >
          <planeBufferGeometry args={headshot ? [scale * 9, scale * 7.25] : [scale * 10, scale * 7]}/>
          <meshBasicMaterial map={texture} toneMapped={false} />
        </mesh>
        {/* <Box
          justify='flex-end' 
          align='flex-end'
        > */}
          <TxtFlex
            posX={2 * scale} 
            posY={-(2 * scale)} 
            text={txtOne}
            textTwo={txtTwo}
            txtColorOne={txtColorOne}
            txtColorTwo={txtColorTwo}
            textAlign='left'
            textScaleFactor={1.15 * scale}
            onReflow={handleThreshold}
          />
        {/* </Box> */}
      </Box>
    </>
  )
};

export default ImgFlex;